export default __webpack_public_path__ + "static/media/wiem.e54a720c.png";